<template>
  <div>

    <page-heading-info
    title="Jefferson County Downloadable Forms"
    ></page-heading-info>

    <text-box-title title="Business Property">
      <note-documents note-id="9" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

    <text-box-title title="Licenses">
      <note-documents note-id="11" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

    <text-box-title title="Real Estate">
      <note-documents note-id="12" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

  </div>
</template>

<script>

import PageHeadingInfo from '@/components/layout/PageHeadingInfo'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'

export default {
  components: {
    PageHeadingInfo,
    TextBoxTitle,
    NoteDocuments
  },
  data () {
    return {}
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {}
}

</script>

<style>
</style>